import Common from "../../../../../Common";

interface Body {
	word: string
}

const TriggerWord = class extends Common {
	browse = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id
	) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/triggerword`)

	create = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		body: Body
	) =>
		this.post(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/triggerword`, body)

	delete = (
		companyId: id,
		profileTemplateId: id,
		profileTemplateProfileId: id,
		wordId: id
	) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}/triggerword/${wordId}`)
}

export default TriggerWord
